/* istanbul ignore file */
import React from 'react';
import PropTypes from 'prop-types';
import {IntlProvider} from 'react-intl';

import {CookiesProvider} from '@stubhub/react-cookies';
import ResponsiveListenerContainer from '@stubhub/react-responsive-listener';
import ThemeProvider from '@stubhub/react-theme-provider';
import {TrackingProvider} from '@stubhub/react-tracking-datalayer';

import onMount from './onMount';
import {StaticContext} from './static-context';

class App extends React.Component {
  static contextTypes = {
    logger: PropTypes.object,
    globalRegistry: PropTypes.object,
  };

  componentDidMount() {
    onMount(this.context);
  }

  render() {
    const {html, messages, cookies, children, locale} = this.props;

    return (
      <StaticContext.Provider value={html}>
        <IntlProvider locale={locale} messages={messages}>
          <TrackingProvider>
            <ResponsiveListenerContainer>
              <ThemeProvider>
                <CookiesProvider instance={cookies}>{children}</CookiesProvider>
              </ThemeProvider>
            </ResponsiveListenerContainer>
          </TrackingProvider>
        </IntlProvider>
      </StaticContext.Provider>
    );
  }
}

App.propTypes = {
  html: PropTypes.object,
  messages: PropTypes.arrayOf(PropTypes.object),
  cookies: PropTypes.object,
  children: PropTypes.node,
  locale: PropTypes.string,
};

export default App;
